import { ITrackedScenarioEvent, ITrackedScenarioParams, ITrackedScenarioPartC } from '@mecontrol/common';
import { ME } from '../../utilities';
import { EventMoment } from '../eventQueue';
import { createPartA } from '../eventGenerator';

const eventName = 'Ms.Webi.MeControl.TrackedScenario';

/**
 * Creates a TrackedScenario event to capture information on some process in MeControl
 * @param requestParams The tracked scenario event's parameters
 * @returns The created TrackedScenario event
 */
export function createTrackedScenario(scenarioParams: ITrackedScenarioParams, moment: EventMoment): ITrackedScenarioEvent {
    const partA = createPartA(eventName, moment.date, moment.cv);

    const partC: ITrackedScenarioPartC = {
        baseType: undefined,
        partner: ME.Config.ptn,
        controlVersion: ME.Config.ver,
        market: ME.Config.mkt,
        scenario: scenarioParams.scenario,
        action: scenarioParams.action,
        previousAction: scenarioParams.previousAction,
        success: scenarioParams.success,
        durationMs: scenarioParams.durationMs,
        details: scenarioParams.details
    };

    return {
        partA,
        partB: undefined,
        partC
    };
}
